import styled from "styled-components";

export const WheelFrameDefaultBox = styled.div`
    /** This creates a positioning context for all children with position: absolute to be rendered at the center */
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;

    /** other styles */
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: #703f1e;
    border: 1px solid #e0d4be;
    box-shadow: hsla(30, 100%, 65%, 0.37) 0 0 7px 2px;

`;